module.exports = __webpack_public_path__ + "media/images/footer/pl_ef-8463f35dd8d873e98d29ac1b46e2530e.svg";